module.exports = __webpack_public_path__ + "static/media/marker2.6003a93a.svg";